import React from "react";
import img from "../assets/whyTechnnovate.jpg"
const Whytechnnovate = () => {
  return (
<>

<div className="bg-white">
    <div className="flex justify-around py-10 max-sm:py-0 max-md:py-0 max-sm:pt-5 items-center px-5 max-sm:flex-col-reverse max-md:flex-col-reverse max-lg:flex-col-reverse flex-row-reverse max-sm:px-0 max-md:px-0">
        <div className="w-1/2 max-lg:w-full max-lg:pl-0 max-sm:w-full max-md:w-full max-sm:text-center max-md:text-center pl-20 max-sm:pl-0 max-md:pl-0">
            <div className={`h-[100px] flex items-center justify-center`}>
    <div className='max-w-md mx-auto  w-full'>
    <h2 className="flex flex-row flex-nowrap items-center my-8">
        <span className="flex-grow block border-t border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
        <span className={`flex-none block px-4 py-2.5  text-2xl font-semibold max-md:text-xl leading-none  uppercase text-[#07c991a8]`}>
        Why SocioLoom
        </span>
        <span className="flex-grow block border-t  border-[#07c991a8]" aria-hidden="true" role="presentation"></span>
    </h2>
    </div>    </div> 

            <p className="text-gray-600 mt-4 text-justify leading-8 max-sm:px-6 max-md:px-6">
At SocioLoom, we understand the challenges small and
medium-sized businesses and startups face. You need results, but
affordability and trust are crucial. That's why we offer
comprehensive web development, digital marketing, growth strategy,
market research, and IT solutions at prices that work for you. We
are dedicated to propelling startups to new heights through our
comprehensive suite of services. As a dynamic and client-focused
company, we specialize in delivering top-notch solutions.</p>

        </div>
        <div className="w-[650px] max-sm:w-full max-md:w-full">
            <img src={img}alt="why SocioLoom" className="w-full h-auto rounded-lg"/>
        </div>
    </div>
</div>

               
 </>
  );
};

export default Whytechnnovate;










